import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { plantDetailLayoutRoute } from "./route";

import { NestedRouteErrorComponent } from "@/components/organisms/ErrorBoundary/NestedRouteErrorComponent";

export const plantPerformanceRoute = createRoute({
  path: "performance",
  getParentRoute: () => plantDetailLayoutRoute,
  component: lazyRouteComponent(async () => {
    const m = await import("./PerformancePage/PerformancePage");
    return { default: m.PerformancePage };
  }),
  errorComponent: NestedRouteErrorComponent,
});
